import { Question } from '@protos/content_management/content.db_pb';

/**
 * Rounds minutes to the nearest whole number, with minimum of 1 minute
 * Prevents "0 Mins" display for small values like 0.08 or 0.17
 */
export const roundMinutes = (seconds: number): number => {
  const minutes = seconds / 60;
  return Math.max(1, Math.round(minutes));
};

/**
 * Calculates total time from an array of questions by summing rounded individual times
 * Each question time is rounded individually before summing to ensure totals match the sum of displayed values
 */
export const calculateTotalTime = (questions: Question[]): number => {
  if (!questions || questions.length === 0) return 0;

  return questions.reduce((acc, curr) => {
    const currentTime =
      curr.question?.model?.value?.commonQuestionContent?.time || 0;
    const roundedMinutes = roundMinutes(currentTime);
    return acc + roundedMinutes;
  }, 0);
};
